import AiTrainingPage from './AiTrainingPage';

export default AiTrainingPage;
